export default __webpack_public_path__ + "static/media/tigerbox_touch_black.cb619f86.png";